import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turnstile"
export default class extends Controller {
  connect() {
    if (!window.turnstile) {
      console.debug("Turnstile element detected, loading Turnstile script...")
      this.loadScript().then(() => {
        console.debug("Turnstile script loaded...")
      })
    } else {
      console.debug("Turnstile API is already available, rendering widget...")
      this.renderWidget()
    }
  }

  /**
   * Dynamically loads the Cloudflare Turnstile script if it is not already present on the page.
   * Ensures the script is loaded only once and resolves when the Turnstile API is available.
   *
   * @returns {Promise<void>} A promise that resolves when the Turnstile script has been loaded and is ready to use.
   */
  loadScript() {
    return new Promise((resolve) => {
      const script = document.createElement("script")
      script.id = "cf-turnstile-script"
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=turnstileLoadedCallback"
      script.async = true
      script.defer = true
      window.turnstileLoadedCallback = () => {
        window.dispatchEvent(new Event("turnstile-loaded"))
        resolve()
      }
      document.head.appendChild(script)
    })
  }

  renderWidget() {
    if (window.turnstile) {
      // Remove any previous widget before rendering a new one
      this.element.innerHTML = ""
      window.turnstile.render(this.element)
    }
  }
}
